export default __webpack_public_path__ + "6f44c644178fc6f2387aea59e0e9b8da.svg";